import CustomButton from "@/components/common/Button";
import { ProColumns } from "@ant-design/pro-components";
import { message, Popconfirm } from "antd";
import { Edit2, Plus, Trash, Copy } from "lucide-react";
import { Link, useNavigate } from "react-router-dom";
import MMNavigationRoutes from "../../utils/navigationRoutes";
import { useQuery } from "@tanstack/react-query";
import CityCollabSettingService from "@/services/APIs/PtsSettingService";
import BaseTable from "@/components/BaseTable/BaseTable";

const SettingsListPage = () => {
  const navigate = useNavigate();

  const { data: settingsData, refetch: refetchSettingsData } = useQuery({
    queryKey: ["settingsData"],
    queryFn: () => CityCollabSettingService.getSetting(),
    enabled: true,
    refetchOnWindowFocus: false,
  });

  console.log(settingsData, "settingsData");

  // Helper to read value from either top-level or record.jso

  const handleDelete = async (id: string) => {
    const response = await CityCollabSettingService.deleteSetting(id);
    if (response) {
      refetchSettingsData();
    }
  };

  const handleEdit = (id: string) => {
    navigate(MMNavigationRoutes.EDIT_SETTINGS(id));
  };

  const handleCopy = async (url: string) => {
    try {
      await navigator.clipboard.writeText(url);
      message.success("Invite URL copied");
    } catch {
      message.error("Copy failed");
    }
  };
  const columns: ProColumns<any>[] = [
    {
      title: "Employee Name",
      dataIndex: "employee_name",
      width: 60,
      render: (_, record) => {
        return (
          <Link to={`/p${MMNavigationRoutes.EDIT_SETTINGS(record.id)}`}>
            {record.organization_name}
          </Link>
        );
      },
    },
    {
      title: "Current Invite URL",
      dataIndex: "invite_code",
      ellipsis: true,
      width: 320,
      render: (_, record) => {
        const chapterId = record.id;
        const baseUrl = `${window.location.origin}/p/${chapterId}?refer_code=`;
        const fullUrl = `${baseUrl}${record.invite_code}`;
        return (
          <div className="flex items-center gap-2">
            <a
              href={fullUrl}
              target="_blank"
              rel="noopener noreferrer"
              className="truncate"
              style={{ maxWidth: 1100 }}
            >
              {fullUrl}
            </a>
            <div className="flex items-center gap-2">
              <Copy
                size={18}
                className="ml-2 cursor-pointer text-green-700 hover:text-green-900"
                onClick={() => handleCopy(fullUrl)}
              />
            </div>
          </div>
        );
      },
    },
    {
      title: "ID",
      dataIndex: "id",
      hidden: true,
    },
    {
      title: "Actions",
      width: 40,
      valueType: "option",
      render: (_, record) => [
        <CustomButton
          key="edit"
          icon={<Edit2 size={16} />}
          onClick={() => handleEdit(record.id)}
          type="text"
        />,
        <Popconfirm
          title="Are you sure you want to delete this settings record?"
          onConfirm={() => handleDelete(record.id)}
          okText="Yes"
          key="delete"
          cancelText="No"
        >
          <CustomButton
            danger
            key="delete"
            icon={<Trash size={16} />}
            type="text"
          />
        </Popconfirm>,
      ],
    },
  ];

  const toolBarRender = () => [
    <CustomButton
      key="add"
      type="primary"
      icon={<Plus size={16} />}
      onClick={() => navigate("/p" + MMNavigationRoutes.CREATE_SETTINGS)}
    >
      Add Settings
    </CustomButton>,
  ];

  return (
    <div>
      <BaseTable<any>
        loading={false}
        columns={columns}
        dataSource={settingsData?.data ?? []}
        page={1}
        pageSize={10}
        total={settingsData?.total ?? 0}
        rowKey="id"
        toolBarRender={toolBarRender}
        headerTitle="Settings"
        onPageChange={() => {}}
      />
    </div>
  );
};

export default SettingsListPage;
